export const getReportPage = (response) => {
  const source = response?.content ? response : response?.data || response || {};
  const rows = Array.isArray(source)
    ? source
    : source?.content || source?.rows || source?.items || source?.reportData || [];
  return {
    rows: Array.isArray(rows) ? rows : [],
    totalPages: Number(source?.totalPages || (rows?.length ? 1 : 0)),
    source,
  };
};

export const exportCsv = (fileName, headers, rows) => {
  const escape = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;
  const content = [headers, ...rows]
    .map((row) => row.map(escape).join(","))
    .join("\n");
  const url = URL.createObjectURL(new Blob([content], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};

export function ReportToolbar({
  size,
  onSizeChange,
  search,
  onSearchChange,
  showSearch = true,
}) {
  return (
    <div className="report-table-toolbar">
      <label>
        Show{" "}
        <select value={size} onChange={onSizeChange}>
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>{" "}
        entries
      </label>
      {showSearch && (
        <label className="report-search-control">
          Search:
          <input
            className="form-control"
            type="search"
            value={search}
            placeholder="Search..."
            onChange={onSearchChange}
          />
        </label>
      )}
    </div>
  );
}

export function ReportPagination({ page, totalPages, onChange }) {
  const lastPage = Math.max(totalPages - 1, 0);
  return (
    <div className="clean-report-pagination">
      <button type="button" disabled={page <= 0} onClick={() => onChange(0)}>«</button>
      <button type="button" disabled={page <= 0} onClick={() => onChange(page - 1)}>‹</button>
      <span>{page + 1}</span>
      <button type="button" disabled={!totalPages || page >= lastPage} onClick={() => onChange(page + 1)}>›</button>
      <button type="button" disabled={!totalPages || page >= lastPage} onClick={() => onChange(lastPage)}>»</button>
    </div>
  );
}

export function ReportExportButtons({ fileName, headers, rows }) {
  return (
    <div className="report-export-buttons">
      <button
        type="button"
        className="report-export-button report-export-excel"
        disabled={!rows.length}
        aria-label="Export Excel CSV"
        onClick={() => exportCsv(`${fileName}.csv`, headers, rows)}
      >
        <i className="fas fa-file-excel" aria-hidden="true" />
      </button>
      <button
        type="button"
        className="report-export-button report-export-pdf"
        disabled={!rows.length}
        aria-label="Print or save PDF"
        onClick={() => window.print()}
      >
        <i className="fas fa-file-pdf" aria-hidden="true" />
      </button>
    </div>
  );
}
